import { OFFER_ACTION_TYPES } from "../../actions/chatbotActions/chatbotActionTypes";

const initialState = {
  loading: false,
  images: null,
  error: null,
};

const getImagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case OFFER_ACTION_TYPES.REQUEST:
      return { ...state, loading: true, error: null };
    case OFFER_ACTION_TYPES.SUCCESS:
      return { ...state, loading: false, images: action.payload };
    case OFFER_ACTION_TYPES.FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default getImagesReducer;
